import { Translation } from '@shared/types/translation';

export const LOADER_LABELS = {
  CERTIFICATE_TEMPLATE_LOADING: {
    english: 'Loading certificate template details...',
    polish: 'Ładowanie szczegółów szablonu certyfikatu…',
  },
} as const satisfies Record<string, Translation>;
